import { configureStore, Middleware } from '@reduxjs/toolkit';
import rootReducer from './rootReducer'; // Import rootReducer
import { deleteState, loadState, saveState } from './localStorage'
import { resetAll, resetForLoading } from './actions' // Assuming this is where resetState is defined
import { getProgramIdFromUrl } from '../utils';

// Define the flag globally in this file
let isResettingState = false;

// Middleware to track resetState actions and prevent saving to localStorage during reset
const resetStateMiddleware: Middleware = (storeAPI) => (next) => (action) => {
  if (action.type === resetAll.type || action.type === resetForLoading.type) {
    isResettingState = true; // Set the flag when resetState is dispatched
  }

  if(action.type === resetAll.type) {
    deleteState()
  }

  // Pass the action to the next middleware or reducer
  return next(action);
};

let preloadedState = loadState(); // Load the preloaded state from localStorage

export const store = configureStore({
  reducer: rootReducer, // Use rootReducer here
  preloadedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(resetStateMiddleware), // Add the resetStateMiddleware
});

// Subscribe to store changes and save state to localStorage, but avoid saving during reset
store.subscribe(() => {
  if (!isResettingState) {
    saveState(store.getState());
  } else {
    // After resetting, turn off the resetting flag
    isResettingState = false;
  }
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;